{
  "name": "operations-mro--mro--fotos-de-componentes--frontend",
  "version": "1.1.19",
  "main": "index.js",
  "type": "module",
  "directories": {
    "doc": "docs"
  },
  "scripts": {
    "dev": "vite",
    "build:watch": "vite build --watch",
    "build:Integration": "vite build --mode integration",
    "build:Preproduction": "vite build --mode preproduction",
    "build:Production": "vite build --mode production",
    "dev:build": "concurrently \"npm:build:watch\" \"npm:preview\"",
    "pre-install": "",
    "build": "vite build",
    "lint": "eslint .",
    "preview": "vite preview",
    "test": "vitest",
    "test:unit": "vitest",
    "test:coverage": "vitest run --coverage",
    "test:coverage:report": "vitest run --coverage && node scripts/openCoverage.cjs",
    "test:contract": "echo contract test",
    "test:acceptance": "echo nothing to test",
    "test:integration": "echo nothing to test",
    "release:initialize": "commit-and-tag-version --first-release",
    "release:dry": "commit-and-tag-version --dry-run",
    "release": "commit-and-tag-version",
    "upload": "cross-env HUSKY=0 commit-and-tag-version --release-as patch",
    "check:format": "prettier --check \"src/**/*.{js,jsx,ts,tsx,json,css,scss,md}\"",
    "format": "prettier --write \"src/**/*.{js,jsx,ts,tsx,json,css,scss,md}\"",
    "prepare": "husky",
    "prepare:linux": "chmod ug+x .husky/*",
    "prepare:default": "",
    "postinstall": "husky install && run-script-os",
    "postinstall:linux": "chmod ug+x .husky/*",
    "postinstall:macos": "chmod ug+x .husky/*",
    "postinstall:windows": "",
    "commit": "cz"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/Iberia-Ent/operations-mro--mro--fotos-de-componentes--frontend.git"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "bugs": {
    "url": "https://github.com/Iberia-Ent/operations-mro--mro--fotos-de-componentes--frontend/issues"
  },
  "homepage": "https://github.com/Iberia-Ent/operations-mro--mro--fotos-de-componentes--frontend#readme",
  "description": "",
  "dependencies": {
    "@tanstack/react-query": "^5.97.0",
    "@tanstack/react-virtual": "^3.13.23",
    "axios": "^1.15.0",
    "clsx": "^2.1.1",
    "graphql": "^16.13.2",
    "graphql-request": "^7.4.0",
    "react": "^18.3.1",
    "react-day-picker": "^9.13.0",
    "react-dom": "^18.3.1",
    "react-hot-toast": "^2.6.0",
    "react-router-dom": "^6.30.2",
    "scanbot-web-sdk": "^6.0.0-dev.6",
    "tailwind-merge": "^3.5.0",
    "zustand": "^5.0.12"
  },
  "devDependencies": {
    "@commitlint/cli": "^20.5.0",
    "@commitlint/config-conventional": "^20.5.0",
    "@originjs/vite-plugin-federation": "^1.4.1",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@types/node": "^25.6.0",
    "@types/react": "^19.2.7",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-v8": "^4.1.4",
    "autoprefixer": "^10.4.27",
    "commit-and-tag-version": "^12.7.1",
    "commitizen": "^4.3.1",
    "concurrently": "^9.2.1",
    "cross-env": "^10.1.0",
    "cz-conventional-changelog": "^3.3.0",
    "eslint": "^9.39.4",
    "eslint-plugin-react-hooks": "^7.0.1",
    "eslint-plugin-react-refresh": "^0.5.2",
    "husky": "^9.1.7",
    "jsdom": "^29.0.2",
    "lint-staged": "^16.4.0",
    "postcss": "^8.5.9",
    "prettier": "^3.8.2",
    "run-script-os": "^1.1.6",
    "tailwindcss": "^3.4.18",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.48.1",
    "vite": "^8.0.8",
    "vite-plugin-static-copy": "^4.0.1",
    "vitest": "^4.1.4"
  },
  "lint-staged": {
    "*.{js,jsx,ts,tsx}": [
      "prettier --write",
      "eslint --fix"
    ],
    "*.{css,scss,md,html,json}": "prettier --ignore-unknown --write"
  },
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-conventional-changelog"
    }
  },
  "commit-and-tag-version": {
    "skip": {
      "tag": true
    }
  }
}
